import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './connectors/redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>  
  </Provider>
  ,document.getElementById('root')) 
  registerServiceWorker()

if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js